import api from '../api/apiConfig'

export default {
  namespaced: true,
  state: {
    current: {},
    currentList: [],
    deletedImages: []
  },
  mutations: {
    setCurrentList (state, inspectionList) {
      state.currentList = inspectionList
    },
    setCurrent (state, inspection) {
      state.current = inspection
    },
    addDeletedImage (state, deletedImage) {
      state.deletedImages.push(deletedImage)
    },
    clearDeletedImages (state) {
      state.deletedImages = []
    }
  },
  actions: {
    setNewInspection ({rootState, commit}) {
      commit('setCurrent', {
        name: null,
        type: null,
        contractor: rootState.project.current.contractor || null,
        subContractor: null,
        inspectedAt: new Date(),
        position: null,
        inspectionPoint: '0',
        inspector: rootState.user.current,
        hasMistake: false,
        stages: [],
        inspectionTiming: [],
        images: []
      })
    },
    async storeInspectionList ({rootState, commit}, filterOptions) {
      commit('setCurrentList', await api.getInspections(rootState.project.current._id, filterOptions))
    },
    async storeInspection ({commit}, _id) {
      commit('setCurrent', await api.getInspection(_id))
    },
    async add ({rootState, state, dispatch, commit}) {
      const newInspection = {...state.current}
      delete newInspection.images

      const _id = await api.addInspection({
        ...newInspection,
        project: rootState.project.current._id
      })

      for (const image of state.current.images) {
        await dispatch('addImage', {_id, imageData: image.file, extension: image.file.name.split('.').pop()})
      }
    },
    async patch ({ state, dispatch, commit }) {
      const newInspection = {...state.current}
      delete newInspection.images

      await api.updateInspection(newInspection)

      // 新增新圖片
      for (const image of state.current.images.filter(image => image.file)) {
        await dispatch('addImage', {_id: state.current._id, imageData: image.file, extension: image.file.name.split('.').pop()})
      }

      // 刪除舊圖片
      for (const image of state.deletedImages) {
        await api.deleteInspectionImage(state.current._id, image._id)
      }
      commit('clearDeletedImages')
      await dispatch('storeInspectionList')
    },
    async addImage ({state}, {_id, imageData, extension}) {
      const { location } = await api.addInspectionImageMeta(_id, {extension})

      await api.addInspectionImageContent(location, imageData)
    },
    async download ({state}, inspection) {
      try {
        let result = await api.downloadInspection([inspection._id])
        require('downloadjs')(result, `${new Date(inspection.inspectedAt).toLocaleDateString().replaceAll('/', '-')} 自主檢查表.docx`, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
      } catch (error) {
        throw error
      }
    },
    async batchDownload ({state}, ids) {
      try {
        let result = await api.downloadInspection(ids)
        require('downloadjs')(result, `自主檢查表.${ids.length === 1 ? 'docx' : 'zip'}`)
      } catch (error) {
        throw error
      }
    },
    async downloadList ({state, rootState}) {
      try {
        let result = await api.downloadInspectionList(rootState.project.current._id)
        require('downloadjs')(result, '自主檢查表.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
      } catch (error) {
        throw error
      }
    },
    async delete ({state, dispatch}, inspectionId) {
      await api.deleteInspection(inspectionId)
      await dispatch('storeInspectionList')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/inspection.js